module.exports = __webpack_public_path__ + "img/bank-transfer-payment.8c6dc1e8.png";